export class ProfileMember {
    id: number;
    barcode: string;

    main: boolean;
    status: string;
    initials: string;
    prefix: string;
    name: string;
    formatted_name: string;
    email: string;
    gender: string;
    date_of_birth: string;
    telephone: string;

    picture: {
        avatar: string;
        thumbnail: string;
        original: string;
    };
    
    is_volunteer: boolean;
    is_lifeguard: boolean;
    is_coordinator: boolean;

    payment_status: string;

    household: ProfileHousehold;

    household_amount: string;

    members: ProfileSubMember[];
    external_members: ProfileSubExternalMember[];
    
    can_view_all_membercards: boolean;
}

export class ProfileSubMember {
    id: number;
    barcode: string;

    main: boolean;
    status: string;
    initials: string;
    prefix: string;
    name: string;
    formatted_name: string;
    email: string;
    gender: string;
    date_of_birth: string;

    picture: {
        avatar: string;
        thumbnail: string;
        original: string;
    };
    
    is_volunteer: boolean;
    is_lifeguard: boolean;
    is_coordinator: boolean;

    payment_status: string;
    can_view_all_membercards: boolean;
}

export class ProfileSubExternalMember {
    id: number;
    barcode: string;

    main: boolean;
    status: string;
    initials: string;
    prefix: string;
    name: string;
    formatted_name: string;
    email: string;
    gender: string;
    date_of_birth: string;

    picture: {
        avatar: string;
        thumbnail: string;
        original: string;
    };
}

export class ProfileHousehold {
    id: number;
    uuid: string;

    prefix: string;
    name: string;
    email: string;
    telephone: string;
    mobilephone: string;
    
    address: string;
    zipcode: string;
    city: string;
    country_id: string;
    
    iban: string;
    bic: string;
    comments: string;

    created_at: string;
    updated_at: string;

    can_add_member: boolean;
}
